<div class="main" [ngClass]="{ 'is-portrait': isPortraitDevice }">
    <div class="container" [ngClass]="{ 'is-portrait': isPortraitDevice }">
        <div class="headlines">
            <h1 *ngIf="!isPortraitDevice" class="headline-m">
                {{ personalDataTitle | translate }}
            </h1>

            <p class="subtitle-m">
                {{ personalDataInfoSubtitle | translate }}
            </p>
        </div>

        <form [formGroup]="formGroup" class="form">
            <!-- gender -->
            <div class="form-row">
                <div class="form-field">
                    <!--//-EJEMPLO-FORM-FIELD-->
                    <p-selectButton
                        id="gender"
                        formControlName="gender"
                        class="p-selectbutton"
                        [options]="genderOptions"
                        optionLabel="label"
                        optionValue="code"
                        (onOptionClick)="onChangeGender($event)"
                    ></p-selectButton>
                </div>
            </div>

            <!-- textName -->
            <div class="form-row">
                <div class="form-input-row">
                    <div class="form-input">
                        <input
                            type="text"
                            class="input"
                            formControlName="textName"
                            id="textName"
                            name="textName"
                            placeholder=""
                            (keyup)="onChangeName($event)"
                        />
                        <label class="input-label" for="textName">{{ personalDataName | translate }}</label>
                        <div *ngIf="this.formGroup.controls.textName.valid" class="input-icon">
                            <i class="ri-check-line class-icono"></i>
                        </div>
                    </div>
                </div>
            </div>

            <!-- textFirst -->
            <div class="form-row">
                <div class="form-input-row">
                    <div class="form-input">
                        <input
                            type="text"
                            class="input"
                            formControlName="textFirst"
                            id="textFirst"
                            name="textFirst"
                            placeholder=""
                            (keyup)="onChangeFirst($event)"
                        />
                        <label class="input-label" for="textFirst">{{ personalDataLastName | translate }}</label>

                        <div *ngIf="this.formGroup.controls.textFirst.valid" class="input-icon">
                            <i class="ri-check-line class-icono"></i>
                        </div>
                    </div>
                </div>
            </div>

            <!-- textSecond -->
            <div class="form-row">
                <div class="form-input-row">
                    <div class="form-input">
                        <input
                            type="text"
                            class="input"
                            formControlName="textSecond"
                            id="textSecond"
                            name="textSecond"
                            placeholder=""
                            (keyup)="onChangeSecond($event)"
                        />
                        <label class="input-label" for="textSecond">{{ personalDataSecondName | translate }}</label>

                        <div *ngIf="this.formGroup.controls.textSecond.valid" class="input-icon">
                            <i class="ri-check-line class-icono"></i>
                        </div>
                    </div>
                </div>
            </div>
        </form>

        <div class="actions">
            <button
                *ngIf="!isPortraitDevice"
                pripple=""
                class="button-secondary button-next"
                type="button"
                [disabled]="backButtonDisabled"
                (click)="onClicButtonBack()"
            >
                <span class="ri-arrow-left-line p-button-icon p-button-icon-left ng-star-inserted"></span>
                <span class="p-button-label-right">{{ backButton | translate }}</span>
            </button>

            <button
                pripple=""
                class="button-primary button-next"
                type="button"
                [disabled]="continueButtonDisabled"
                (click)="onClicButtonContinue()"
                [ngClass]="{ 'is-portrait': isPortraitDevice }"
            >
                <span class="p-button-label-left">{{ continueButton | translate }}</span>
                <span class="ri-arrow-right-line p-button-icon p-button-icon-right ng-star-inserted"></span>
            </button>
        </div>
    </div>

    <div *ngIf="isPortraitDevice">
        <app-footer></app-footer>
    </div>

    <div class="chat-layer">
        <app-chat-layer></app-chat-layer>
    </div>
</div>
